import PropTypes from 'prop-types'
import { Redirect } from 'react-router-dom'

import injectRole from '../../components/HOC/injectRole'
import { TRoutes } from '../../shared/const'
import { mayOpenAdminPage } from '../../shared/alumni'

import Handbook from '../../components/views/admin/Handbook'

/**
 * Handbuch — nur für die Administration.
 *
 * Es beschreibt auch die Abläufe von Schüler:innen und Lehrkräften, richtet
 * sich aber an Admins: Dort sitzt das Wissen, das über ein Schuljahr hinweg
 * gebraucht wird.
 */
function HandbookPage(props) {
	if (mayOpenAdminPage(props.role, 'handbook')) return <Handbook />

	return <Redirect to={TRoutes.DASHBOARD} />
}

HandbookPage.propTypes = {
	role: PropTypes.string.isRequired
}

export default injectRole(HandbookPage)
